import { retryUserIdentityMigration } from '~src/app/actions/spaces/UserIdentityActions';
import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';

import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RetryUserIdentityMigrationAction: IEntityAction<IUserIdentityConflictInfo, {}> = {
  name: EntityActionNames.RetryUserIdentityMigration,
  translateName: Messages.identityMigration_RetryMigrationAction,
  isVisible: (targetItems: IUserIdentityConflictInfo[], state: AppState) => true,
  isClickable: (availableActions: {}, targetItems: IUserIdentityConflictInfo[], state: AppState) => true,
  createReduxAction: (targetItems: IUserIdentityConflictInfo[]) => retryUserIdentityMigration(targetItems)
};

